import Dialog from "../../../components/game/Dialog";
import { TACardType } from "../../../types";
import { tacAudioData } from "../constants";
import { TACGameState } from "../types";

export default function TACDialog({
  currentCard,
  gameState,
  backAudioIndex,
}: {
  currentCard: TACardType | null;
  gameState: TACGameState;
  backAudioIndex: number;
}) {
  if (
    currentCard === null ||
    (gameState !== "frontPlaying" &&
      gameState !== "waitingForFlipping" &&
      gameState !== "backPlaying" &&
      gameState !== "waitingForReplay")
  )
    return null;

  const { frontAudio, backAudio } = tacAudioData[currentCard];
  const { text } =
    gameState === "frontPlaying" || gameState === "waitingForFlipping"
      ? frontAudio
      : backAudio[backAudioIndex];

  return <Dialog text={text} className="relative z-20" />;
}
